import { createHttpLink } from '@apollo/client';
import { toCommercetoolsApiUrl } from '../models/clientConfig';
import fetch from './fetchWithToken';

export const commercetoolsHttpLink = createHttpLink({
  uri: toCommercetoolsApiUrl(),
  fetch,
});
